export function productPromotionTranslationKeysFor(sku) {
  return {
    description: `product.promotions.${sku}.description`,
    "description-with-value": `product.promotions.${sku}.description-with-value`,
    "description-alternative": `product.promotions.${sku}.description-alternative`,
    price: `product.promotions.${sku}.price`,
  };
}
